import en from './en.json';
import zh from './zh.json';

const translations = { en, zh };

// Get language from localStorage or default to 'en'
function getLang() {
  return localStorage.getItem('uhome_lang') || 'en';
}

function setLang(lang) {
  localStorage.setItem('uhome_lang', lang);
  window.dispatchEvent(new Event('langChange'));
}

function t(key) {
  const lang = getLang();
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  // Fallback to English if value is missing
  if (!value && lang !== 'en') {
    value = translations.en;
    for (const k of keys) {
      value = value?.[k];
    }
  }
  return value || key;
}

export { t, getLang, setLang };
